/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import styles from './Summary.module.scss';
import {formatCurrency} from "../../../util/format";
import {CashPeriodSumDataInterface} from "../CashPeriod.interface";

interface SummaryProps {
	title: string;
	data: CashPeriodSumDataInterface;
}

const Summary = ({ title, data }: SummaryProps) => {
	return (
		<div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', fontVariant: 'tabular-nums' }}>
			{title}
			<div>
				입금: <span className={styles.deposit}>{formatCurrency(data.depositSum || 0, 'KRW')}</span>
			</div>
			<div>
				출금: <span className={styles.withdrawal}>{formatCurrency(data.withdrawalSum || 0, 'KRW')}</span>
			</div>
			<div>
				합계: <span className={styles.netDifference}>{formatCurrency(data.netDifference || 0, 'KRW')}</span>
			</div>
		</div>
	);
};

export default Summary;
